import { render } from "./Patient_SNV_Table.vue?vue&type=template&id=1b09a6b2"
import script from "./Patient_SNV_Table.vue?vue&type=script&lang=js"
export * from "./Patient_SNV_Table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__